import { getProducts } from "./selectors";

const getSponsoredProducts = state => {
  const products = getProducts(state);

  return products.filter(product => product.isSponsored);
};

export default getSponsoredProducts;
